import { Check, ExternalLink, Shield } from 'lucide-react';

const SCOPE_LABELS: Record<string, string> = {
  openid: 'Identifier votre compte',
  email: 'Lire votre adresse email',
  profile: 'Lire votre nom et profil',
};

function describeScope(scope: string): string {
  return SCOPE_LABELS[scope] ?? scope;
}

interface ConsentClientDetailsProps {
  readonly clientName: string;
  readonly clientUri: string;
  readonly clientLogo: string;
  readonly scope: string;
}

/** Who asks (name, site, logo) and what for (the requested scopes, in words). */
export function ConsentClientDetails({ clientName, clientUri, clientLogo, scope }: ConsentClientDetailsProps) {
  const scopes = scope.split(/\s+/).filter((s) => s.length > 0);
  return (
    <>
      <div className="flex items-start">
        <div className="flex-shrink-0 h-10 w-10 rounded-lg bg-neutral-100 flex items-center justify-center overflow-hidden">
          {clientLogo.length > 0
            ? <img src={clientLogo} alt={clientName} className="h-10 w-10 object-cover" />
            : <Shield className="h-5 w-5 text-neutral-400" />}
        </div>
        <div className="ml-3 flex-1 min-w-0">
          <p className="text-sm font-medium text-neutral-900 truncate">{clientName}</p>
          {clientUri.length > 0 && (
            <a
              href={clientUri}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-0.5 inline-flex items-center text-xs text-[#0066FF] hover:underline"
            >
              {clientUri}
              <ExternalLink className="ml-1 h-3 w-3" />
            </a>
          )}
        </div>
      </div>

      <div>
        <p className="text-xs uppercase font-medium text-neutral-500 tracking-wide mb-2">Permissions demandées</p>
        {scopes.length === 0
          ? <p className="text-sm text-neutral-500 italic">Aucune permission spécifique.</p>
          : (
            <ul className="space-y-2">
              {scopes.map((s) => (
                <li key={s} className="flex items-start">
                  <Check className="h-4 w-4 text-green-500 mr-2 mt-0.5 flex-shrink-0" />
                  <span className="text-sm text-neutral-800">{describeScope(s)}</span>
                </li>
              ))}
            </ul>
          )}
      </div>
    </>
  );
}
